module.exports = __webpack_public_path__ + "img/1440.b1a70a17.jpg";